// src/utils/translations.js
export const translations = {
    es: {
        navbar: {
            logo: {
                prefix: "Dev",
                suffix: "Portafolio"
            },
            links: {
                home: "Inicio",
                about: "Sobre mí",
                experience: "Experiencia",
                projects: "Proyectos",
                certifications: "Certificaciones",
                skills: "Habilidades",
                contact: "Contacto"
            }
        },
        hero: {
            greeting: "Hola, soy",
            name: "Erick Torres Hernández",
            roles: ['Full Stack Software Engineer', 'Ingeniero en Sistemas'],
            prefix: "Soy ",
            description: 'Full Stack Software Engineer | Ingeniero en Sistemas de Información',
            buttons: {
                contact: "Contáctame",
                projects: "Ver Proyectos"
            }
        },
        about: {
            title: "Sobre Mí",
            description: "Ingeniero en Sistemas con más de 2 años construyendo y manteniendo plataformas SaaS en producción con Node.js, Laravel, .NET y React. Experiencia integrando pagos con Stripe, modernizando bases de código heredadas en producción y reemplazando procesos manuales por software, aplicando principios de Arquitectura Limpia para construir software mantenible. Conocimientos prácticos en contenerización y orquestación de infraestructura con Docker y Kubernetes.",
            highlights: {
                education: {
                    title: "Formación Académica",
                    description: "Bachillerato en Ingeniería en Sistemas de Información (graduado, noviembre 2025) · Licenciatura en Desarrollo de Sistemas Web (en curso) — Universidad Nacional de Costa Rica"
                },
                experience: {
                    title: "Experiencia",
                    description: "Desarrollo full-stack y mantenimiento de plataformas SaaS escalables"
                },
                methodology: {
                    title: "Metodología",
                    description: "Enfoque analítico y soluciones creativas para retos complejos"
                }
            },
            technologies: {
                languages: "Lenguajes",
                frameworks: "Frameworks",
                databases: "Bases de Datos"
            }
        },
        experience: {
            title: "Experiencia Profesional",
            achievements: "Logros Principales:",
            positions: [
                {
                    title: "Software Engineer - Full Stack",
                    company: "Midware",
                    period: "Julio 2025 – Presente",
                    description: "Diseño e implementación de nuevas funcionalidades para plataformas SaaS empresariales, traduciendo requerimientos complejos de negocio en soluciones técnicas que aumentan la competitividad del producto.",
                    achievements: [
                        "Desarrollo de servicios de alto rendimiento con TypeScript (Node.js), aplicando principios de arquitectura limpia para asegurar código modular, mantenible y escalable",
                        "Gestión de despliegues en producción mediante entornos contenerizados, garantizando la estabilidad de los servicios y minimizando tiempos de inactividad",
                        "Reducción del tiempo de depuración y deuda técnica al establecer estándares de código estrictos y buenas prácticas a lo largo del ciclo de vida del software"
                    ],
                    technologies: ["SvelteKit", "Fastify", "TypeScript", "PostgreSQL", "Docker", "Kubernetes"]
                },
                {
                    title: "Software Engineer - Full Stack",
                    company: "Correos de Costa Rica",
                    period: "Febrero 2024 – Junio 2025",
                    description: "Desarrollo y despliegue del sistema institucional de gestión de flotilla vehicular utilizando Laravel y React, transformando procesos manuales y dispersos en una plataforma digital unificada que centraliza el control y la trazabilidad de los activos vehiculares.",
                    achievements: [
                        "Automatización del ciclo de vida completo de las órdenes de reparación, disminuyendo la carga administrativa y errores humanos al habilitar registro, seguimiento y auditoría en tiempo real",
                        "Diseño e implementación de una arquitectura escalable y robusta, garantizando la integridad de los datos relacionales, la ejecución consistente de reglas de negocio y una experiencia de usuario fluida",
                        "Integración de Apache Superset para la creación de dashboards interactivos y reportes automatizados, apoyando a la gerencia con datos precisos para el análisis de costos y la toma de decisiones estratégicas"
                    ],
                    technologies: ["Laravel", "React", "PostgreSQL", "Apache Superset"]
                }
            ]
        },
        projects: {
            title: "Proyectos Destacados",
            readMore: "Leer más",
            showLess: "Mostrar menos",
            mainFeatures: "Características Principales:",
            links: {
                code: "Código",
                demo: "Demo"
            },
            filterBy: "Filtrar por:",
            allProjects: "Todos",
            list: [
                {
                    title: "TaskFlow",
                    description: "Plataforma colaborativa para gestión de proyectos que permite a los equipos organizar tareas, responsabilidades y progreso en un solo espacio compartido.",
                    features: [
                        "Motor de IA que genera automáticamente estructuras completas de proyectos a partir de instrucciones en lenguaje natural, reduciendo el tiempo de planificación",
                        "Funcionalidades de colaboración en tiempo real que permiten a los equipos visualizar y actualizar tareas de forma instantánea",
                        "Mecanismos de autenticación segura y control de acceso por roles para proteger la información y gestionar múltiples equipos"
                    ],
                    technologies: [
                        { name: "React", color: "#61DAFB" },
                        { name: "Fastify", color: "#3B82F6" },
                        { name: "PostgreSQL", color: "#336791" },
                        { name: "Node.js", color: "#68A063" },
                        { name: "IA", color: "#FF6F61" }
                    ],
                    githubUrl: "#",
                    liveUrl: "https://etorres.lat"
                },
                {
                    title: "Sistema de seguimiento y control de la flotilla vehicular",
                    description: "Sistema desarrollado para llevar el control de la flotilla vehicular de la empresa Correos de Costa Rica, incluyendo el manejo de reparaciones de vehículos, la revisión diaria de cada unidad, y la generación de reportes estadísticos.",
                    features: [
                        "Dashboard interactivo con estadísticas en tiempo real",
                        "Sistema de gestión de mantenimientos y reparaciones",
                        "Módulo de reportes y análisis de datos",
                        "Control de usuarios y permisos"
                    ],
                    technologies: [
                        { name: "Laravel", color: "#FF2D20" },
                        { name: "React", color: "#61DAFB" },
                        { name: "PostgreSQL", color: "#336791" },
                        { name: "Node.js", color: "#68A063" }
                    ],
                    githubUrl: "#",
                    liveUrl: "#"
                },
                {
                    title: "Simulación de Plataforma de Correo Electrónico con archivos de texto",
                    description: "Este proyecto es una simulación de una plataforma de correo electrónico desarrollada en Racket bajo el paradigma de programación funcional. La plataforma utiliza archivos de texto para almacenar datos en lugar de bases de datos tradicionales, y cuenta con una interfaz gráfica simple diseñada en HTML y Bootstrap, lo que proporciona una experiencia visual amigable y moderna.",
                    features: [
                        "Interfaz gráfica amigable",
                        "Almacenamiento en archivos de texto",
                        "Programación funcional pura"
                    ],
                    technologies: [
                        { name: "Racket", color: "#9F1D20" },
                        { name: "HTML", color: "#E34F26" },
                        { name: "Bootstrap", color: "#7952B3" }
                    ],
                    githubUrl: "https://github.com/ErickTorres6412/Simulaci-n-de-correo-en-racket",
                    liveUrl: "#"
                },
                {
                    title: "Pokedex",
                    description: "Aplicación web para la visualización de información de Pokémon, construida con React y la API de Pokémon.",
                    features: [
                        "Búsqueda y filtrado de Pokémon",
                        "Visualización de estadísticas y habilidades",
                        "Interfaz amigable y responsiva"
                    ],
                    technologies: [
                        { name: "React", color: "#61DAFB" },
                        { name: "JavaScript", color: "#F7DF1E" },
                        { name: "CSS", color: "#1572B6" },
                        { name: "Node.js", color: "#68A063" }
                    ],
                    githubUrl: "https://github.com/ErickTorres6412/pokedex_midware_test",
                    liveUrl: "https://pokedex-midware-test.vercel.app/ "
                }
            ]
        },
        certificates: {
            title: "Educación y Certificaciones",
            categories: {
                all: "Todos",
                academic: "Títulos Universitarios",
                technical: "Certificaciones"
            },
            stats: {
                certificates: "Certificados",
                institutions: "Instituciones"
            },
            actions: {
                view: "Ver",
                download: "Descargar"
            },
            list: [
                {
                    title: "Bachillerato en Ingeniería en Sistemas de Información",
                    institution: "Universidad Nacional de Costa Rica",
                    date: "2025",
                    category: "academic",
                    badges: ["Desarrollo", "Informática", "Universidad"]
                },
                {
                    title: "Certificado Fundamentos de Scrum",
                    institution: "SCRUMstudy",
                    date: "2026",
                    category: "technical",
                    badges: ["Agile", "Gestión", "Metodologías"]
                },
                {
                    title: "Spring Framework y Spring Boot",
                    institution: "Código Facilito",
                    date: "2024",
                    category: "technical",
                    badges: ["Java", "Backend", "Framework"]
                },
                {
                    title: "Diplomado De Programación De Aplicaciones Informáticas",
                    institution: "Universidad Nacional de Costa Rica",
                    date: "2024",
                    category: "academic",
                    badges: ["Programación", "Informática", "Universidad"]
                }
            ]
        },
        skills: {
            title: "Mis Habilidades",
            technical: {
                title: "Habilidades Técnicas",
                categories: [
                    {
                        title: 'Frontend',
                        skills: [
                            'TypeScript, JavaScript',
                            'React, SvelteKit',
                            'Tailwind 4',
                            'Responsive Design'
                        ]
                    },
                    {
                        title: 'Backend',
                        skills: [
                            'Java',
                            'PHP',
                            'TypeScript',
                            'RESTful APIs'
                        ]
                    },
                    {
                        title: 'Bases de Datos',
                        skills: [
                            'SQL Server',
                            'PostgreSQL',
                            'Diseño de DB'
                        ]
                    },
                    {
                        title: 'Herramientas',
                        skills: [
                            'Git, GitHub',
                            'Docker, Kubernetes',
                            'AWS, Azure',
                            'WordPress'
                        ]
                    }
                ]
            },
            soft: {
                title: "Habilidades Blandas",
                skills: [
                    {
                        name: "Comunicación efectiva",
                        description: "Capacidad para expresar ideas técnicas de forma clara y concisa a diferentes audiencias."
                    },
                    {
                        name: "Resolución de problemas",
                        description: "Enfoque analítico para identificar soluciones eficientes ante desafíos complejos."
                    },
                    {
                        name: "Trabajo en equipo",
                        description: "Experiencia colaborando en equipos multidisciplinarios para lograr objetivos comunes."
                    },
                    {
                        name: "Gestión del tiempo",
                        description: "Habilidad para priorizar tareas y cumplir con plazos en entornos dinámicos."
                    },
                    {
                        name: "Adaptabilidad",
                        description: "Flexibilidad para aprender nuevas tecnologías y metodologías según las necesidades del proyecto."
                    },
                    {
                        name: "Pensamiento crítico",
                        description: "Capacidad de analizar requisitos y proponer mejoras desde una perspectiva técnica y de negocio."
                    }
                ]
            }
        },
        contact: {
            title: "Contáctame",
            subtitle: "¿Tienes un proyecto interesante?",
            info: {
                email: {
                    label: "Email",
                    value: "ericktorres7314@gmail.com"
                },
                location: {
                    label: "Ubicación",
                    value: "Alajuela, Costa Rica"
                },
                phone: {
                    label: "Teléfono",
                    value: ""
                }
            },
            form: {
                name: "Nombre",
                email: "Email",
                subject: "Asunto",
                message: "Mensaje",
                submit: "Enviar Mensaje",
                sending: "Enviando..."
            },
            notifications: {
                success: "¡Mensaje enviado con éxito!",
                error: "Error al enviar el mensaje. Por favor, intenta nuevamente."
            }
        },
        footer: {
            contact: {
                title: "Contacto",
                email: "Email:",
                phone: "Teléfono:",
                location: "Ubicación:"
            },
            quickLinks: {
                title: "Enlaces Rápidos",
                home: "Inicio",
                about: "Sobre Mí",
                experience: "Experiencia",
                projects: "Proyectos",
                skills: "Habilidades",
                certifications: "Certificaciones",
                contact: "Contacto"
            }
        }
    },
    en: {
        navbar: {
            logo: {
                prefix: "Dev",
                suffix: "Portfolio"
            },
            links: {
                home: "Home",
                about: "About me",
                experience: "Experience",
                projects: "Projects",
                certifications: "Certifications",
                skills: "Skills",
                contact: "Contact"
            }
        },
        hero: {
            greeting: "Hi, I'm",
            name: "Erick Torres Hernández",
            roles: ['Full Stack Software Engineer', 'Information Systems Engineer'],
            prefix: "I'm a ",
            description: "Full Stack Software Engineer | Information Systems Engineer",
            buttons: {
                contact: "Contact Me",
                projects: "View Projects"
            }
        },
        about: {
            title: "About Me",
            description: "Full Stack Software Engineer with 2+ years building and maintaining production SaaS platforms with Node.js, Laravel, .NET and React. Experience integrating Stripe payments, modernizing legacy production codebases, and replacing manual business processes with software, applying Clean Architecture to keep production software maintainable. Practical experience with containerization and infrastructure orchestration using Docker and Kubernetes.",
            highlights: {
                education: {
                    title: "Education",
                    description: "Bachelor’s Degree in Information Systems Engineering (Bachillerato, graduated November 2025) · Licenciatura in Web Systems Development (post-bachelor’s, in progress) — Universidad Nacional de Costa Rica"
                },
                experience: {
                    title: "Experience",
                    description: "Full-stack development and maintenance of scalable SaaS platforms"
                },
                methodology: {
                    title: "Methodology",
                    description: "Analytical approach and creative solutions for complex challenges"
                }
            },
            technologies: {
                languages: "Languages",
                frameworks: "Frameworks",
                databases: "Databases"
            }
        },
        experience: {
            title: "Professional Experience",
            achievements: "Key Achievements:",
            positions: [
                {
                    title: "Software Engineer - Full Stack",
                    company: "Midware",
                    period: "July 2025 – Present",
                    description: "Design and implementation of new features for enterprise SaaS platforms, translating complex business requirements into technical solutions that improve product competitiveness.",
                    achievements: [
                        "Development of high-performance services using TypeScript (Node.js), applying Clean Architecture principles to ensure modular, maintainable, and scalable code",
                        "Ensuring service stability in production by managing deployments through containerized environments, minimizing downtime for end users",
                        "Reducing debugging time and technical debt by establishing strict coding standards and development best practices throughout the software lifecycle"
                    ],
                    technologies: ["SvelteKit", "Fastify", "TypeScript", "PostgreSQL", "Docker", "Kubernetes"]
                },
                {
                    title: "Software Engineer - Full Stack",
                    company: "Correos de Costa Rica",
                    period: "February 2024 – June 2025",
                    description: "Developed and deployed the institutional fleet management system using Laravel and React, migrating scattered manual processes into a unified digital platform that significantly improved control and traceability of vehicle assets.",
                    achievements: [
                        "Automated the full repair order lifecycle, reducing administrative workload and human errors by enabling real-time maintenance registration, tracking, and auditing",
                        "Designed a robust and scalable full-stack architecture, ensuring data integrity, consistent business rules, and a smooth user experience for internal staff",
                        "Implemented interactive dashboards and automated reports using Apache Superset, enabling accurate cost analysis and supporting management in strategic decision-making"
                    ],
                    technologies: ["Laravel", "React", "PostgreSQL", "SuperSet"]
                }
            ]
        },
        projects: {
            title: "Featured Projects",
            readMore: "Read more",
            showLess: "Show less",
            mainFeatures: "Main Features:",
            links: {
                code: "Code",
                demo: "Demo"
            },
            filterBy: "Filter by:",
            allProjects: "All",
            list: [
                {
                    title: "TaskFlow",
                    description: "Collaborative project management platform that enables teams to organize tasks, responsibilities, and progress within a shared workspace.",
                    features: [
                        "AI-powered engine that automatically generates complete project structures from natural language prompts, significantly reducing planning time",
                        "Real-time collaboration features that allow teams to view and update tasks instantly, improving coordination and project tracking",
                        "Secure authentication and role-based access control to protect sensitive information and support collaboration across multiple teams"
                    ],
                    technologies: [
                        { name: "React", color: "#61DAFB" },
                        { name: "Fastify", color: "#3B82F6" },
                        { name: "PostgreSQL", color: "#336791" },
                        { name: "Node.js", color: "#68A063" },
                        { name: "AI", color: "#FF6F61" }
                    ],
                    githubUrl: "#",
                    liveUrl: "https://etorres.lat"
                },
                {
                    title: "Vehicle Fleet Tracking and Control System",
                    description: "System developed to control the vehicle fleet of Correos de Costa Rica company, including vehicle repair management, daily unit inspection, and statistical report generation.",
                    features: [
                        "Interactive dashboard with real-time statistics",
                        "Maintenance and repair management system",
                        "Reports and data analysis module",
                        "User and permissions control"
                    ],
                    technologies: [
                        { name: "Laravel", color: "#FF2D20" },
                        { name: "React", color: "#61DAFB" },
                        { name: "PostgreSQL", color: "#336791" },
                        { name: "Node.js", color: "#68A063" }
                    ],
                    githubUrl: "#",
                    liveUrl: "#"
                },
                {
                    title: "Email Platform Simulation with Text Files",
                    description: "This project is an email platform simulation developed in Racket under the functional programming paradigm. The platform uses text files for data storage instead of traditional databases and features a simple graphical interface designed in HTML and Bootstrap, providing a friendly and modern visual experience.",
                    features: [
                        "User-friendly graphical interface",
                        "Text file storage",
                        "Pure functional programming"
                    ],
                    technologies: [
                        { name: "Racket", color: "#9F1D20" },
                        { name: "HTML", color: "#E34F26" },
                        { name: "Bootstrap", color: "#7952B3" }
                    ],
                    githubUrl: "https://github.com/ErickTorres6412/Simulaci-n-de-correo-en-racket",
                    liveUrl: "#"
                },
                {
                    title: "Pokedex",
                    description: "Web application for viewing Pokémon information, built with React and the Pokémon API.",
                    features: [
                        "Pokémon search and filtering",
                        "Display of stats and abilities",
                        "User-friendly and responsive interface"
                    ],
                    technologies: [
                        { name: "React", color: "#61DAFB" },
                        { name: "JavaScript", color: "#F7DF1E" },
                        { name: "CSS", color: "#1572B6" },
                        { name: "Node.js", color: "#68A063" }
                    ],
                    githubUrl: "https://github.com/ErickTorres6412/pokedex_midware_test",
                    liveUrl: "https://pokedex-midware-test.vercel.app/"
                }
            ]
        },
        certificates: {
            title: "Education & Certifications",
            categories: {
                all: "All",
                academic: "University Degrees",
                technical: "Certifications"
            },
            stats: {
                certificates: "Certificates",
                institutions: "Institutions"
            },
            actions: {
                view: "View",
                download: "Download"
            },
            list: [
                {
                    title: "Bachelor’s Degree in Information Systems Engineering",
                    institution: "National University of Costa Rica",
                    date: "2025",
                    category: "academic",
                    badges: ["Development", "Computer Science", "University"]
                },
                {
                    title: "Scrum Fundamentals Certified",
                    institution: "SCRUMstudy",
                    date: "2026",
                    category: "technical",
                    badges: ["Agile", "Management", "Methodologies"]
                },
                {
                    title: "Spring Framework and Spring Boot",
                    institution: "Código Facilito",
                    date: "2024",
                    category: "technical",
                    badges: ["Java", "Backend", "Framework"]
                },
                {
                    title: "Diploma in Computer Application Programming",
                    institution: "National University of Costa Rica",
                    date: "2024",
                    category: "academic",
                    badges: ["Programming", "Computer Science", "University"]
                }
            ]
        },
        skills: {
            title: "My Skills",
            technical: {
                title: "Technical Skills",
                categories: [
                    {
                        title: 'Frontend',
                        skills: [
                            'TypeScript, JavaScript',
                            'React, SvelteKit',
                            'Tailwind 4',
                            'Responsive Design'
                        ]
                    },
                    {
                        title: 'Backend',
                        skills: [
                            'Java',
                            'PHP',
                            'TypeScript',
                            'RESTful APIs'
                        ]
                    },
                    {
                        title: 'Databases',
                        skills: [
                            'SQL Server',
                            'PostgreSQL',
                            'DB Design'
                        ]
                    },
                    {
                        title: 'Tools',
                        skills: [
                            'Git, GitHub',
                            'Docker, Kubernetes',
                            'AWS, Azure',
                            'WordPress'
                        ]
                    }
                ]
            },
            soft: {
                title: "Soft Skills",
                skills: [
                    {
                        name: "Effective Communication",
                        description: "Ability to express technical ideas clearly and concisely to different audiences."
                    },
                    {
                        name: "Problem Solving",
                        description: "Analytical approach to identify efficient solutions to complex challenges."
                    },
                    {
                        name: "Teamwork",
                        description: "Experience collaborating in multidisciplinary teams to achieve common goals."
                    },
                    {
                        name: "Time Management",
                        description: "Ability to prioritize tasks and meet deadlines in dynamic environments."
                    },
                    {
                        name: "Adaptability",
                        description: "Flexibility to learn new technologies and methodologies according to project needs."
                    },
                    {
                        name: "Critical Thinking",
                        description: "Ability to analyze requirements and propose improvements from a technical and business perspective."
                    }
                ]
            }
        },
        contact: {
            title: "Contact Me",
            subtitle: "Have an interesting project?",
            info: {
                email: {
                    label: "Email",
                    value: "ericktorres7314@gmail.com"
                },
                location: {
                    label: "Location",
                    value: "Alajuela, Costa Rica"
                },
                phone: {
                    label: "Phone",
                    value: ""
                }
            },
            form: {
                name: "Name",
                email: "Email",
                subject: "Subject",
                message: "Message",
                submit: "Send Message",
                sending: "Sending..."
            },
            notifications: {
                success: "Message sent successfully!",
                error: "Error sending message. Please try again."
            }
        },
        footer: {
            contact: {
                title: "Contact",
                email: "Email:",
                phone: "Phone:",
                location: "Location:"
            },
            quickLinks: {
                title: "Quick Links",
                home: "Home",
                about: "About Me",
                experience: "Experience",
                projects: "Projects",
                skills: "Skills",
                certifications: "Certifications",
                contact: "Contact"
            }
        }
    }
};